import React from 'react';

/**
 * PotDisplay Component
 * Renders the central pot with chip stack visualization
 */
export default function PotDisplay({ pot, creditValue, phase }) {
  const potValue = pot * creditValue;
  
  return (
    <div
      style={{
        position: 'absolute',
        top: '45%', // Raised up by 5% (from 50% to 45%)
        left: '50%',
        transform: 'translate(-50%, -50%)',
        textAlign: 'center',
        zIndex: 5,
        pointerEvents: 'none'
      }}
    >
      {/* Chip stack visualization removed - chip count is shown in the text below */}
      
      {/* Pot value text - scaled down by 5% */}
      <div
        style={{
          background: 'rgba(0, 0, 0, 0.7)',
          color: 'white',
          padding: '7.6px 15.2px', // Reduced by 5% (8px * 0.95 = 7.6px, 16px * 0.95 = 15.2px)
          borderRadius: '7.6px', // Reduced by 5% (8px * 0.95 = 7.6px)
          fontWeight: '700',
          fontSize: '1.1875rem', // Reduced by 5% (1.25rem * 0.95 = 1.1875rem)
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
          border: '2px solid rgba(255, 255, 255, 0.2)',
          transform: 'scale(0.95)' // Scale down entire box by 5%
        }}
      >
        <div style={{ fontSize: '0.83125rem', opacity: 0.9, marginBottom: '2px' }}> {/* Reduced by 5% (0.875rem * 0.95 = 0.83125rem) */}
          Pot
        </div>
        <div>
          {pot} chips
        </div>
        <div style={{ fontSize: '0.7125rem', opacity: 0.8, marginTop: '2px' }}> {/* Reduced by 5% (0.75rem * 0.95 = 0.7125rem) */}
          ${potValue.toFixed(2)}
        </div>
      </div>
      
      {/* Phase label */}
      {phase && phase !== 'waiting' && (
        <div
          style={{
            marginTop: '8px',
            color: 'white',
            fontSize: '0.875rem',
            fontWeight: '600',
            textShadow: '0 2px 4px rgba(0, 0, 0, 0.5)',
            opacity: 0.9
          }}
        >
          {phase === 'suitvote' && 'Vote for Dealer Suit'}
          {phase === 'dealer_reveal' && 'Finding Dealer...'}
          {phase === 'deal' && 'Dealing cards...'}
          {phase === 'action' && 'Deciding knock/discard...'}
          {phase === 'reveal' && 'Revealing knocked hands...'}
          {phase === 'results' && 'Hand Complete!'}
        </div>
      )}
    </div>
  );
}

